import React, { useState, useEffect } from "react";
import App from "../App";
import animationData from "../../Assets/loading.json";
import Lottie from "react-lottie";
import "./loader.css";

export default function Loader() {
  // Loading state
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Wait for 3 seconds
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return isLoading ? (
    <div className="load">
      <Lottie options={defaultOptions} height={200} width={200} />
    </div>
  ) : (
    <App />
  );
}
